import { SWR_KEYS } from '@bulknutrients/bulk-shared-lib/constants';
import type { LoginAPIResponse } from 'pages/api/customer/login';
import { useSWRConfig } from 'swr';

export function useLogin() {
  const { mutate } = useSWRConfig();

  return async (details: {
    email: string;
    password: string;
    captchaCode: string;
  }) => {
    const loginRes: LoginAPIResponse = await fetch('/api/customer/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(details),
    }).then((res) => res.json());

    mutate(SWR_KEYS.customer);
    mutate(SWR_KEYS.alerts);
    mutate(SWR_KEYS.wishlist);

    return loginRes;
  };
}
